<div class="frame-to-search">
  <mat-card class="mat-card--widget">
    <ecp-loader *ngIf="frameLoading$ | async" class="search-loader"></ecp-loader>
    <mat-card-content>
      <div class="container">
        <div class="row">
          <div class="col m4 s12">
            <mat-form-field>
              <mat-select
                name="laboratory"
                [(ngModel)]="selectedLab"
                [disabled]="isLocked()"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Select a laboratory"
              >
                <mat-option value="primary" *ngIf="manageCareLabList?.primary">{{
                  manageCareLabList.primary?.displayName
                }}</mat-option>
                <ng-container *ngIf="manageCareLabList?.managedCare?.length !== 0">
                  <mat-option value="managed_care">Secondary Laboratory</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col m4 s12">
            <ng-container *ngIf="selectedLab == 'managed_care'">
              <mat-form-field>
                <mat-label>Select a Secondary Laboratory</mat-label>
                <mat-select [(ngModel)]="locationSelected" name="manageCareLab" [disabled]="isLocked()"aria-label="Send frame to">
                  <mat-option
                    *ngFor="let manageCareLab of manageCareLabList.managedCare"
                    [value]="manageCareLab"
                    class="manage-care-radio mb-10"
                  >
                    {{ manageCareLab.displayName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
          </div>
        </div>
        <div class="row">
          <div class="col m10 s12">
            <mat-form-field>
              <input
                matInput
                [(ngModel)]="searchVal"
                [ngModelOptions]="{ standalone: true }"
                autoFocus
                placeholder="Search"
              />
              <mat-hint>Enter or scan a UPC to find a frame</mat-hint>
            </mat-form-field>
          </div>
          <div class="col s12 m2 mt-20">
            <button
              mat-icon-button
              class="btn btn-outline btn-secondary align-left"
              (click)="searchUpc()"
              aria-label="Search Catalog"
              type="button"
            >
              <mat-icon>search</mat-icon>
              Search
            </button>
          </div>
        </div>
      </div>
      <form [formGroup]="frameForm">
        <div class="container">
          <!-- SEARCH ATTRIBUTE -->
          <div class="row">
            <div class="col m3 s12">
              <mat-form-field>
                <input matInput formControlName="upc" placeholder="UPC" [readonly]="isFrameFound" />
              </mat-form-field>
            </div>
            <div class="col m3 s12">
              <mat-form-field>
                <input matInput formControlName="brand" placeholder="Brand" required [readonly]="isFrameFound" />
              </mat-form-field>
            </div>
            <div class="col m3 s12">
              <mat-form-field>
                <input matInput formControlName="style" placeholder="Style" required [readonly]="isFrameFound" />
              </mat-form-field>
            </div>
            <div class="col m3 s12">
              <mat-form-field>
                <input matInput formControlName="color" placeholder="Color" required [readonly]="isFrameFound" />
              </mat-form-field>
            </div>
          </div>
          <!-- RX / PROVIDER TYPE SECTION -->
          <div class="row">
            <div class="col m4 s12">
              <mat-form-field>
                <mat-select
                  name="provider"
                  formControlName="provider"
                  (selectionChange)="changeRxOrderIdPattern()"
                  placeholder="Select a Provider Type"
                >
                  <mat-option value="privatepay">PRIVATE PAY</mat-option>
                  <mat-option value="eyemed">EYEMED</mat-option>
                  <mat-option value="uhc">UHC VISION - SPECTERA</mat-option>
                  <mat-option value="vba">VBA</mat-option>
                  <mat-option value="versant">VERSANT</mat-option>
                  <mat-option value="vsp">VSP</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col m3 s12">
              <mat-form-field>
                <label class="custom--input-label"
                  >RX Order ID
                  <fa-icon class="icon__info" (click)="tooltip.toggle()" icon="info-circle"></fa-icon>
                  <span
                    #tooltip="matTooltip"
                    matTooltip="Your RX order ID is: &#13; &#13; &#8226; Private Pay: Vision Web E-order # (i.e. SP1234AB) or Eyefinity Order # (i.e. Z12345678) &#13; &#8226; Eyemed: Eyemed Claim Number / E-Order Confirmation (i.e. SP1234AB) &#13; &#8226; UHC Vision / Spectera: Spectera Tracking Number (V1234567890123) &#13; &#8226; VBA: VBA Rx Order # (i.e. 1234567890) &#13; &#8226;  Versant: Versant Order Confirmation (i.e. SP1234AB) &#13; &#8226; VSP: Eyefinity Lab Order / Benefit Number (i.e. 12345678) &#13;
                              Not providing a valid RX Order ID will delay delivery time"
                    matTooltipClass="multiline-tooltip"
                    matTooltipPosition="above"
                  ></span>
                </label>
                <input matInput type="text" formControlName="rxOrderId" (keyup)="changeRxOrderIdPattern()" />
                <mat-error *ngIf="frameForm.get('rxOrderId').errors">
                  <fa-icon icon="exclamation-triangle"></fa-icon>
                  Please enter a valid RX ID.
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col m3 s12">
              <mat-form-field>
                <mat-select name="frameCondition" formControlName="frameCondition" placeholder="Select Frame Condition">
                  <mat-option value="New Patient Own Frame">New Patient Own Frame</mat-option>
                  <mat-option value="Used Patient Own Frame">Used Patient Own Frame</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <!-- PATIENTS NAME -->
          <div class="row">
            <div class="col m4 s12">
              <mat-form-field>
                <input matInput type="text" formControlName="patientFirstName" placeholder="First Name" required />
              </mat-form-field>
            </div>
            <div class="col m4 s12">
              <mat-form-field>
                <input matInput type="text" formControlName="patientLastName" placeholder="Last Name" required />
              </mat-form-field>
            </div>
          </div>
          <!-- Action Button -->
          <div class="row">
            <div class="col s12 offset-m5 action-button">
              <button
                class="btn btn-primary align-left"
                aria-label="Add to Shipping"
                type="button"
                (click)="addShippingLabel($event)"
                [disabled]="isValidForm()"
                #cartToolTip="matTooltip"
                [matTooltip]="itemExistMessage"
                matTooltipPosition="above"
              >
                Add to Shipping
              </button>
              <ng-container *ngIf="!isFromDetails; else updateOrder">
                <button
                  class="btn btn-primary align-left"
                  aria-label="Save Frame To Come"
                  type="button"
                  [disabled]="isToSave()"
                  (click)="saveShippingLabel()"
                >
                  <ng-container *ngIf="frameSave; else frameSaving"> Save</ng-container>
                  <ng-template #frameSaving><fa-icon icon="spinner" [spin]="true"></fa-icon> Saving</ng-template>
                </button>
                <button
                  [disabled]="isToGenerate()"
                  class="btn btn-primary align-left"
                  aria-label="Generate Shipping"
                  type="button"
                  (click)="saveAndGenerate()"
                >
                  Generate Shipping Label
                </button>
              </ng-container>
              <ng-template #updateOrder>
                <!-- <button
                  class="btn btn-primary align-left"
                  aria-label="Update Order"
                  type="button"
                  (click)="generateShippingLabel()"
                >
                  Update Shipping Label
                </button> -->
              </ng-template>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
<ecp-can-leave [dontLeave]="changesDetected" [disableClose]="true" #canLeave>
  <div [class]="theme ? theme : 'one-portal'">
    <h2 mat-dialog-title><b>Unsaved changes</b></h2>

    <mat-dialog-content>
      You have unsaved changes which will be lost. Are you sure you wish to leave this page?
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button class="btn btn-primary" (click)="canLeave.close(false)" cdkFocusInitial>Stay on This Page</button>
      <button class="btn btn-secondary" (click)="canLeave.close(true)">Leave This Page</button>
    </mat-dialog-actions>
  </div>
</ecp-can-leave>
